// Configuración de la API
import { ENVIRONMENT } from './environment';

// URL base de la API
const API_URL = ENVIRONMENT.API_URL;

// URL para el backend DemoCrudInt
export const DEMO_CRUD_INT_API_URL = ENVIRONMENT.API_URL;
export const DEMO_CRUD_CHAR_API_URL = ENVIRONMENT.API_URL;
export const DEMO_CRUD_CHAR2_API_URL = ENVIRONMENT.API_URL;

export { API_URL };

// Función para obtener la URL completa de un endpoint
export const getApiUrl = (endpoint) => {
  return `${API_URL}${endpoint}`;
};

// Función para obtener la URL completa de un endpoint para DemoCrudInt
export const getDemoCrudIntApiUrl = (endpoint) => {
  return `${DEMO_CRUD_INT_API_URL}${endpoint}`;
};

// Función para obtener la URL completa de un endpoint para DemoCrudChar
export const getDemoCrudCharApiUrl = (endpoint) => {
  return `${DEMO_CRUD_CHAR_API_URL}${endpoint}`;
};

// Función para obtener la URL completa de un endpoint para DemoCrudChar2
export const getDemoCrudChar2ApiUrl = (endpoint) => {
  return `${DEMO_CRUD_CHAR2_API_URL}${endpoint}`;
};

// Función para obtener la URL completa de un endpoint para la API CrudApi
/* export const getCrudApiUrl = (endpoint) => {
  return `${BASE_API_URL}${endpoint}`;
}; */
